import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "onChange", "precision", "value", "onBlur", "disabled", "multi"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Textarea from 'react-autosize-textarea';
import { observer } from 'mobx-react';
import NumericInput from '../../../../components/NumericInput';
import DateTimeInput from '../../../../components/DateTimeInput';
import styles from './Input.m.sass';
var Input = function Input(_ref) {
  var type = _ref.type,
    _onChange = _ref.onChange,
    _ref$precision = _ref.precision,
    precision = _ref$precision === void 0 ? 0 : _ref$precision,
    value = _ref.value,
    onBlur = _ref.onBlur,
    disabled = _ref.disabled,
    multi = _ref.multi,
    props = _objectWithoutProperties(_ref, _excluded);
  var makeInputProps = function makeInputProps(inputProps) {
    return _objectSpread({
      type: type,
      value: value,
      disabled: disabled,
      className: styles.control,
      onChange: function onChange(e) {
        return !disabled && _onChange(e.target.value);
      },
      onBlur: onBlur
    }, inputProps);
  };
  var makeInput = function makeInput(inputProps) {
    return /*#__PURE__*/React.createElement(multi ? Textarea : 'input', makeInputProps(inputProps));
  };
  return type === 'number' ? /*#__PURE__*/React.createElement(NumericInput, {
    precision: precision,
    value: value,
    onChange: function onChange(v) {
      return !disabled && _onChange(Number.isNaN(v) ? 0 : v);
    },
    onBlur: onBlur,
    disabled: disabled,
    mode: "live",
    formatInputValue: true
  }, function (inputProps, actions) {
    return makeInput(_objectSpread(_objectSpread(_objectSpread({
      onKeyPress: actions.keyPressPreventNonNumeric
    }, props), inputProps), {}, {
      type: 'text'
    }));
  }) : type === 'date' || type === 'datetime-local' ? /*#__PURE__*/React.createElement(DateTimeInput, _extends({}, makeInputProps(props), {
    disabled: disabled,
    onChange: function onChange(v) {
      return !disabled && _onChange(v);
    }
  })) : makeInput(props);
};
export default observer(Input);
//# sourceMappingURL=index.js.map
